@let cartItems = items();

<div class="flex flex-col h-full">
  <!-- Header -->
  <div class="flex items-center justify-between p-6 border-b border-gray-200">
    <div class="flex items-center gap-3">
      <mat-icon aria-hidden="true" class="!text-primary !text-2xl"
        >shopping_bag</mat-icon
      >
      <div>
        <h2 class="text-xl font-bold text-gray-900">Carrito de Compras</h2>
        <p class="text-sm text-gray-500">
          {{ cartService.totalItems() }}
          {{ cartService.totalItems() === 1 ? "producto" : "productos" }}
        </p>
      </div>
    </div>
    <button
      appButton
      variant="ghost"
      size="icon"
      class="hover:!bg-gray-100"
      (click)="closeCart()"
      aria-label="Cerrar carrito"
    >
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>

  <!-- Cart Items -->
  <div class="flex-1 overflow-y-auto px-6">
    @if (cartItems.length === 0) {
      <!-- Empty State -->
      <div class="flex flex-col items-center justify-center py-20 text-center">
        <mat-icon
          aria-hidden="true"
          class="!text-6xl !w-16 !h-16 text-gray-300 mb-4"
          >shopping_bag</mat-icon
        >
        <h3 class="text-lg font-medium text-gray-900 mb-2">
          Tu carrito está vacío
        </h3>
        <p class="text-gray-500 mb-6">
          Agrega productos para comenzar tu compra
        </p>
        <a
          routerLink="/catalog"
          appButton
          variant="default"
          (click)="closeCart()"
        >
          Explorar Productos
        </a>
      </div>
    } @else {
      <!-- Items List -->
      <div class="py-6 space-y-4">
        @for (item of cartItems; track item.product.CodProd) {
          <div class="flex gap-4 pb-4 border-b border-gray-200 last:border-b-0">
            <!-- Product Image -->
            <div
              class="w-20 h-20 bg-gray-100 rounded-lg overflow-hidden shrink-0"
            >
              <img
                [src]="item.product.productImages[0]?.imageUrl"
                appProductImgFallback
                [alt]="item.product | productTitle"
                loading="lazy"
                class="w-full h-full object-cover"
              />
            </div>

            <!-- Product Info -->
            <div class="flex-1 min-w-0">
              <div class="flex justify-between items-start mb-1">
                <div class="min-w-0 pr-2">
                  <h3 class="font-medium text-gray-900 text-sm line-clamp-1">
                    {{ item.product | productTitle }}
                  </h3>
                  <p class="text-xs text-gray-500">{{ item.product.Refere }}</p>
                  <p class="text-xs text-gray-400">
                    SKU: {{ item.product.CodProd }}
                  </p>
                </div>
                <button
                  appButton
                  variant="ghost"
                  size="icon"
                  class="!h-8 !w-8 -mt-1 -mr-2 hover:!bg-red-50 hover:!text-red-600"
                  (click)="removeItem(item.product.CodProd)"
                  aria-label="Eliminar producto"
                >
                  <mat-icon aria-hidden="true" class="!text-base"
                    >delete</mat-icon
                  >
                </button>
              </div>

              <div class="flex items-center justify-between mt-2">
                <!-- Quantity Controls -->
                <div
                  class="flex items-center gap-2 rounded-lg p-1 w-full max-w-[136px]"
                >
                  <app-cart-controls [product]="item.product" class="w-full" />
                </div>

                <!-- Price -->
                <div class="text-right">
                  @if (item.product.priceWithTax) {
                    <p class="font-bold text-primary">
                      {{
                        item.product.priceWithTax * item.quantity | clpCurrency
                      }}
                    </p>
                    @if (item.quantity > 1) {
                      <p class="text-xs text-gray-500">
                        {{ item.product.priceWithTax | clpCurrency }} c/u
                      </p>
                    }
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>

  <!-- Footer - Summary and Checkout -->
  @if (cartItems.length > 0) {
    <div class="border-t border-gray-200 p-6 bg-gray-50">
      <!-- Summary -->
      <div class="space-y-2 mb-4">
        @if (cartService.totalAmount(); as total) {
          <div appSeparator></div>
          <div class="flex justify-between text-lg">
            <span class="font-bold text-gray-900">Total</span>
            <span class="font-bold text-primary">{{
              total | clpCurrency
            }}</span>
          </div>
        }
      </div>

      <!-- Checkout Button -->
      <a
        appButton
        variant="default"
        size="lg"
        class="w-full"
        routerLink="/checkout"
        (click)="closeCart()"
      >
        <mat-icon aria-hidden="true">shopping_cart_checkout</mat-icon>
        Ir al Checkout
        <mat-icon aria-hidden="true">arrow_forward</mat-icon>
      </a>

      <!-- Continue Shopping -->
      <button
        appButton
        variant="ghost"
        class="w-full mt-2"
        (click)="closeCart()"
      >
        Continuar Comprando
      </button>
    </div>
  }
</div>
